import { Text } from "atomize"
import { useContext } from "react"
import { theme } from "../settings/config"
import { profileContext } from "../providers/profile.provider"
import { schoolContext } from "../providers/school.provider"
import { lessonAuthorshipLines } from "../utils/authorship.utils"
import CardInset from "./CardInset"

// In piccolo, in fondo alla lezione aperta: chi l'ha inserita e chi l'ha
// modificata per ultimo, quando non è il suo maestro. Il resto delle volte
// non c'è niente da dire, e non si dice niente.
function LessonAuthorship({ lessonData }) {
	const { coach } = useContext(profileContext)
	const { getSelectedSchool } = useContext(schoolContext)

	const school = getSelectedSchool()
	// chi è uscito dal circolo non ha più un nome qui: resta il suo nome utente
	const nameOf = coachID => school?.coaches?.[coachID]?.coachName?.split(" ")[0] || coachID

	const lines = lessonAuthorshipLines(lessonData, { myCoachID: coach?.coachID, nameOf })
	if (lines.length === 0) return null

	return (
		<CardInset m={{ t: "0.75rem" }}>
			{lines.map(line => (
				<Text key={line} textSize="caption" textColor={theme.colors.gunmetal} textAlign="right">
					{line}
				</Text>
			))}
		</CardInset>
	)
}

export default LessonAuthorship
